import { FormattedMessage } from 'react-intl';
import { InfoTooltip } from '@/shared/components/Tooltip';

interface Props {
  labelId: string;
  tooltipId?: string;
  variant?: 'block' | 'inline';
}

export default function StepHeading({ labelId, tooltipId, variant = 'block' }: Props) {
  const spacing = variant === 'block' ? 'mb-3' : '';

  return (
    <div className={`flex items-center gap-2 ${spacing}`.trim()}>
      <h3 className="text-sm font-semibold text-slate-700">
        <FormattedMessage id={labelId} />
      </h3>
      {tooltipId && <InfoTooltip content={<FormattedMessage id={tooltipId} />} />}
    </div>
  );
}
